/* ============================================================
   LA QUATERNA
   aria = i testi · fuoco = le immagini · acqua = i video · terra = i modelli 3d
   (lo scambio fuoco/terra e' esoterico e ci sta: la foto e' luce catturata,
    il modello 3d e' l'unica cosa del quadro che ha volume, peso, materia)
   Al centro la quintessenza: l'opera.
   Ogni elemento ha la sua direzione fissa: la posizione di un contenuto
   non e' mai casuale, si sa sempre dove guardare.
   Il caos sta nel fondo procedurale, e la sua densita' E' la quantita' di materiale.
   ============================================================ */

/* Nel prototipo i contenuti erano scritti a mano. Qui li porta la scheda:
   il tema smista i media del prodotto (immagini, video, modelli 3d) e la
   descrizione, e li lascia in window.BM_QUATERNA. Da qui in giu' il motore
   e' identico a quello provato: non sa da dove vengono, li veste e basta. */
var Q = window.BM_QUATERNA || {};
var SALA = document.getElementById("bm-quaterna");

/* ---------- le parole ----------
   La descrizione della scheda e' fatta sempre allo stesso modo: prima riga
   tecnica (titolo, materiali, misura), poi il racconto, in fondo la parte
   di servizio uguale per tutti. Il racconto e' l'aria; la riga tecnica va
   in fondo alla pagina; il resto non si mostra. */
function leggiDescrizione() {
  var d = document.getElementById("qdesc"), fuori = { tecnica: "", parti: [] };
  if (!d) return fuori;
  var noti = /non passa dal carrello|scrivimi e ci mettiamo|legge 633|diritti d.autore|prezzo di listino|prezzo qui sopra/i;
  var tecnico = /acrilico|olio su|tecnica mista|pennarello|su tela|su carta|\d+\s*[x×]\s*\d+/i;
  [].forEach.call(d.querySelectorAll("p,li,h6"), function (n) {
    var t = (n.textContent || "").replace(/\s+/g, " ").trim();
    if (!t || t.length < 3) return;
    if (n.tagName === "H6" || noti.test(t)) return;
    if (!fuori.tecnica && tecnico.test(t)) {
      /* la riga tecnica ricomincia sempre col titolo, che e' gia' scritto
         grande qui sopra: si toglie, resta solo cosa e' e quanto misura */
      var tt = (Q.t || "").trim();
      if (tt && t.toLowerCase().indexOf(tt.toLowerCase()) === 0)
        t = t.slice(tt.length).replace(/^[\s,.—–-]+/, "");
      fuori.tecnica = t.charAt(0).toUpperCase() + t.slice(1);
      return;
    }
    fuori.parti.push(t);
  });
  return fuori;
}
var DESC = leggiDescrizione();

var ELEMENTI = [
  { k:"aria",  nome:"aria",  cosa:"le parole",  dir:-90, col:"#bcd8e8" },
  { k:"fuoco", nome:"fuoco", cosa:"la luce",    dir:  0, col:"#ff7a2f" },
  { k:"terra", nome:"terra", cosa:"la materia", dir: 90, col:"#d2a544" },
  { k:"acqua", nome:"acqua", cosa:"il tempo",   dir:180, col:"#3fb6cf" }
];

/* aria = le parole, fuoco = le immagini, acqua = i video, terra = i modelli 3d.
   Se un elemento non c'e', resta vuoto: la pagina lo dice invece di fingere. */
var DIM = {
  aria:  [],
  fuoco: (Q.fuoco || []),
  terra: (Q.terra || []),
  acqua: (Q.acqua || [])
};
if (DESC.parti.length) {
  DIM.aria.push({ et: "la lettura del quadro",
                  dipinto: Q.t || document.title,
                  testo: DESC.parti });
}

/* i sigilli alchemici, disegnati: niente font esotici da sperare */
var SIG = {
  fuoco:'<svg viewBox="0 0 24 24"><path d="M12 3 L22 21 H2 Z" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>',
  aria :'<svg viewBox="0 0 24 24"><path d="M12 3 L22 21 H2 Z" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M6.2 15.5 H17.8" stroke="currentColor" stroke-width="1.5"/></svg>',
  acqua:'<svg viewBox="0 0 24 24"><path d="M12 21 L2 3 H22 Z" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>',
  terra:'<svg viewBox="0 0 24 24"><path d="M12 21 L2 3 H22 Z" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M6.2 8.5 H17.8" stroke="currentColor" stroke-width="1.5"/></svg>'
};

var campo = document.getElementById("campo"), TUTTI = [], visti = {};

ELEMENTI.forEach(function (E) {
  var lista = DIM[E.k] || [];
  E.n = lista.length;

  var p = document.createElement("div");
  p.className = "polo " + E.k + (E.n ? "" : " vuoto");
  p.innerHTML = SIG[E.k] + "<b>" + E.nome + "</b><i>" + E.cosa + " · " +
                (E.n ? E.n : "nulla, ancora") + "</i>";
  campo.appendChild(p);

  lista.forEach(function (m, i) {
    m.el = E; var idx = TUTTI.push(m) - 1; m.gi = idx;
    var b = document.createElement("button");
    b.className = "sat " + E.k; b.dataset.i = idx; b.dataset.p = i;
    m.b = b;

    var dentro;
    if (E.k === "aria")
      dentro = '<span class="frase">' + m.dipinto.toLowerCase() + "</span>";
    else if (E.k === "terra")
      dentro = '<span class="segno">3D</span>';
    else if (E.k === "acqua")
      dentro = '<video src="' + m.src + '" poster="' + m.pos + '" muted loop playsinline autoplay preload="auto"></video>' +
               '<span class="durata">' + m.dur + "</span>";
    else                                   /* fuoco: la foto, a diamante */
      dentro = '<img src="' + m.src + '" alt="">';

    b.innerHTML = '<span class="box">' + dentro + '</span><span class="et">' + m.et + "</span>";
    campo.appendChild(b);
  });
});

/* ---------- la disposizione ----------
   Il passo angolare non e' scelto a occhio: si misura quanto e' largo davvero
   un contenuto sullo schermo di adesso, e si apre l'arco quel tanto che basta
   perche' due vicini non si tocchino mai. Oltre i 5 si sdoppia su due raggi
   invece di stringersi: e' cosi' che un quadro con 20 foto resta leggibile. */
function disponi() {
  var lato = Math.min(campo.clientWidth, campo.clientHeight);
  if (!lato) return;
  var stretto = innerWidth < 660;
  var maxN = Math.max.apply(null, ELEMENTI.map(function (E) { return (DIM[E.k] || []).length; }));

  /* la misura di un contenuto dipende da quanti sono: un quadro ricchissimo
     mostra molti segni fitti, uno povero pochi e grandi. La densita' si vede
     prima di leggere qualsiasi numero. */
  var largo = (stretto ? 15 : 11.5) *
              (maxN <= 2 ? 1 : maxN <= 5 ? .82 : maxN <= 9 ? .66 : maxN <= 16 ? .54 : .44);
  var px = Math.max(26, largo / 100 * lato);
  largo = px / lato * 100;

  ELEMENTI.forEach(function (E) {
    var lista = DIM[E.k] || [];
    if (!lista.length) return;
    /* il rombo della terra sta in piedi sulla punta: occupa la diagonale,
       non il lato. Se il conto non lo sa, due cristalli si toccano agli spigoli. */
    var ingombro = largo * (E.k === "terra" ? 1.15 : 1);
    var messi = 0, giro = 0, R = 30;
    while (messi < lista.length && giro < 4) {
      var passo = 2 * Math.asin(Math.min(.99, ingombro * 1.24 / (2 * R))) * 180 / Math.PI;
      /* il settore resta il suo: un elemento non sconfina in quello vicino */
      var arco = Math.max(0, 90 - passo);
      var cap = Math.max(1, Math.floor(arco / passo) + 1);
      var quanti = Math.min(cap, lista.length - messi);
      var largoTot = passo * (quanti - 1);
      var sfals = giro % 2 ? passo / 2 : 0;
      for (var i = 0; i < quanti; i++) {
        var m = lista[messi + i];
        var a = E.dir - largoTot / 2 + passo * i + sfals;
        m.b.style.setProperty("--a", a + "deg");
        m.b.style.setProperty("--r", R + "cqmin");
        m.b.style.setProperty("--w", px + "px");
        m.b.style.display = "";
        m.b.classList.remove("oltre");
      }
      messi += quanti; giro++;
      R += ingombro * 1.3;
      if (R + ingombro / 2 > 44) break;              // oltre il campo non si va
    }
    /* se proprio non ci stanno tutti, l'ultimo posto diventa la porta agli altri */
    if (messi < lista.length) {
      var ult = lista[messi - 1], resto = lista.length - messi + 1;
      ult.b.classList.add("oltre");
      ult.b.dataset.i = lista[messi].gi;          // la porta si apre sul primo nascosto
      ult.b.querySelector(".box").innerHTML = "<b>+" + resto + "</b>";
      for (var j = messi; j < lista.length; j++) lista[j].b.style.display = "none";
    }
  });
}
disponi(); addEventListener("resize", disponi);
if (document.fonts && document.fonts.ready) document.fonts.ready.then(disponi);

/* quanti elementi sono presenti: e' questo il grado di una dimensione */
var pieni = ELEMENTI.filter(function (E) { return E.n; });
var vuoti = ELEMENTI.filter(function (E) { return !E.n; });
/* la riga tecnica: e' la prima riga della descrizione, quella che dice
   materiali e misura. Se non c'e', il posto resta vuoto invece di inventare. */
var tec = document.getElementById("tecnica");
if (tec) tec.innerHTML = DESC.tecnica ? DESC.tecnica + "<br>" : "";
document.getElementById("nTot").textContent = TUTTI.length;
document.getElementById("etDensita").textContent =
  "dimensione a " + pieni.length + " element" + (pieni.length === 1 ? "o" : "i") +
  (pieni.length === 4 ? " · compiuta" : "");
document.getElementById("mancanza").textContent = vuoti.length
  ? "di questo quadro manca ancora " + vuoti.map(function (E) { return E.nome; }).join(" e ") + "."
  : "la quaterna è completa.";
function dipingiSigilli() {
  document.getElementById("sigilli").innerHTML = ELEMENTI.map(function (E) {
    return '<span style="color:' + E.col + '">' +
      SIG[E.k].replace("<svg", '<svg class="' + (E.n ? "c" : "") + '"') + "</span>";
  }).join("");
}
dipingiSigilli();

/* ---------- il visore ---------- */
var visore = document.getElementById("visore"), vcorpo = document.getElementById("vcorpo");
var vet = document.getElementById("vet"), vel = document.getElementById("vel");
var vtipo = document.getElementById("vtipo"), punti = document.getElementById("punti"), qui = -1;

TUTTI.forEach(function (m, i) {
  var p = document.createElement("i");
  p.style.setProperty("--c", m.el.col);
  p.onclick = function () { apri(i); };
  punti.appendChild(p);
});

function segna() {
  var n = Object.keys(visti).length;
  document.getElementById("nVisti").textContent = n;
  /* attraversata tutta: le altre dimensioni smettono di nascondersi.
     E' l'unico momento in cui la pagina chiede qualcosa al visitatore. */
  var tutto = n >= TUTTI.length && TUTTI.length > 0;
  SALA.classList.toggle("aperto", tutto);
  var alt = document.getElementById("altrove");
  if (alt) alt.textContent = tutto ? " · l'hai attraversata tutta: agli angoli ce ne sono altre." : "";
  document.querySelectorAll(".sat").forEach(function (b) {
    if (visti[b.dataset.i]) b.classList.add("visto");
  });
  [].forEach.call(punti.children, function (p, i) {
    p.className = i === qui ? "qui" : "";
    p.style.background = visti[i] ? TUTTI[i].el.col : "rgba(242,237,224,.2)";
  });
}

function apri(i) {
  qui = i; visti[i] = 1;
  var m = TUTTI[i], E = m.el, n;
  [].forEach.call(vcorpo.querySelectorAll(":not(.freccia)"), function (x) { x.remove(); });

  if (E.k === "fuoco") { n = new Image(); n.src = m.src; }
  else if (E.k === "acqua") {
    n = document.createElement("video");
    n.src = m.src; n.controls = n.autoplay = n.loop = n.playsInline = true;
  } else if (E.k === "terra") {
    n = document.createElement("model-viewer");
    n.src = m.src; n.setAttribute("camera-controls", ""); n.setAttribute("auto-rotate", "");
    n.setAttribute("shadow-intensity", "1"); n.setAttribute("exposure", "1.1");
  } else {
    n = document.createElement("div"); n.className = "vtesto";
    n.innerHTML = "<h3>" + m.et + "</h3>" +
      '<p class="dipinto">&laquo;' + m.dipinto + "&raquo;</p>" +
      m.testo.map(function (t) { return "<p>" + t + "</p>"; }).join("");
  }
  vcorpo.appendChild(n);
  vet.textContent = m.et;
  vel.innerHTML = '<span style="color:' + E.col + '">' + E.nome + " · " + E.cosa + "</span>";
  vtipo.textContent = (i + 1) + " / " + TUTTI.length;
  visore.classList.add("aperto");
  segna();
}
function chiudiV() {
  visore.classList.remove("aperto"); qui = -1; segna();
  var v = vcorpo.querySelector("video"); if (v) v.pause();
}

document.getElementById("tela").onclick = function () {
  /* la quintessenza: l'opera a schermo pieno, fuori dagli elementi */
  qui = -1;
  [].forEach.call(vcorpo.querySelectorAll(":not(.freccia)"), function (x) { x.remove(); });
  var n = new Image(); n.src = Q.telaGrande || Q.tela; vcorpo.appendChild(n);
  vet.textContent = Q.t || "";
  vel.innerHTML = '<span style="color:#f2ede0">quintessenza · l\'opera</span>';
  vtipo.textContent = "";
  visore.classList.add("aperto");
};
campo.addEventListener("click", function (e) {
  var b = e.target.closest(".sat"); if (b) apri(+b.dataset.i);
});
document.getElementById("vtorna").onclick = chiudiV;
document.getElementById("vpre").onclick = function () { apri((qui - 1 + TUTTI.length) % TUTTI.length); };
document.getElementById("vsuc").onclick = function () { apri((qui + 1) % TUTTI.length); };
document.addEventListener("keydown", function (e) {
  if (!visore.classList.contains("aperto")) return;
  if (e.key === "Escape") chiudiV();
  if (e.key === "ArrowRight") apri((qui + 1) % TUTTI.length);
  if (e.key === "ArrowLeft") apri((qui - 1 + TUTTI.length) % TUTTI.length);
});

/* ---------- le altre dimensioni ----------
   Il campo ha quattro assi occupati e quattro diagonali libere: li' stanno i
   quadri vicini. Non sono una griglia di prodotti correlati, sono mondi
   intravisti dal bordo di questo — e sono link veri alle loro schede.
   L'elenco (quaterna-quadri.js) e' ordinato per serie e poi per titolo: cosi'
   "quadro successivo" resta dentro lo stesso mondo finche' quel mondo non
   finisce, e il cambio di serie diventa un evento invece che un caso. */
var QUADRI = (window.BM_QUATERNA_LISTA || []).slice();
var ORDINE_SERIE = ["Robot", "Facce", "Dreampunk", "Fuori serie"];
function posto(q) {
  var i = ORDINE_SERIE.indexOf(q.s || "");
  return [i < 0 ? 99 : i, (q.t || "").toLowerCase()];
}
var qui_quadro = -1;
for (var iq = 0; iq < QUADRI.length; iq++) if (QUADRI[iq].h === Q.h) { qui_quadro = iq; break; }
if (qui_quadro < 0 && Q.h) {
  /* quadro nuovo, elenco non ancora rigenerato: lo infilo io al suo posto
     con la stessa regola del generatore, cosi' la sequenza resta giusta
     invece di sparire. */
  var mio = { h: Q.h, t: Q.t, s: Q.s || "", f: Q.tela };
  var pm = posto(mio); qui_quadro = QUADRI.length;
  for (var jq = 0; jq < QUADRI.length; jq++) {
    var pj = posto(QUADRI[jq]);
    if (pm[0] < pj[0] || (pm[0] === pj[0] && pm[1] < pj[1])) { qui_quadro = jq; break; }
  }
  QUADRI.splice(qui_quadro, 0, mio);
}

/* Non sono quattro quadri a caso: sono la sequenza. Indietro a sinistra,
   avanti a destra, e piu' sali piu' ti allontani nell'ordine — il campo
   diventa un corridoio. */
var VIE = [
  { d: -1, a: 135, et: "quadro precedente", corto: "precedente" },
  { d:  1, a:  45, et: "quadro successivo", corto: "successivo" },
  { d: -2, a: 225, et: "due quadri prima",  corto: "prima", via: 1 },
  { d:  2, a: -45, et: "due quadri dopo",   corto: "dopo",  via: 1 }
];

function portali() {
  [].forEach.call(campo.querySelectorAll(".porta"), function (x) { x.remove(); });
  var n = QUADRI.length;
  if (n < 2 || qui_quadro < 0) return;
  VIE.forEach(function (v) {
    var q = QUADRI[((qui_quadro + v.d) % n + n) % n];
    if (!q || q.h === Q.h) return;
    var b = document.createElement("a");
    b.className = "porta" + (v.via ? " lontana" : "");
    b.href = "/products/" + q.h;
    b.style.setProperty("--a", v.a + "deg");
    b.innerHTML =
      '<span class="nome"><b>' + q.t + "</b><i>" + (q.s || "BiancoMat") + "</i></span>" +
      '<span class="disco"><img src="' + q.f + '" alt="" loading="lazy"></span>' +
      '<span class="quanti"><em class="lungo">' + v.et +
        '</em><em class="corto">' + v.corto + "</em></span>";
    campo.appendChild(b);
  });
}
portali();

/* il bottone del prezzo non c'e' sui quadri gia' venduti: la pagina resta,
   la domanda no. Quindi si chiede se esiste prima di attaccarcisi. */
var chiedi = document.getElementById("chiedi"), btnPrezzo = document.getElementById("btnPrezzo");
if (chiedi) {
  if (btnPrezzo) btnPrezzo.onclick = function () { chiedi.classList.add("aperto"); };
  var chiudiChiedi = document.getElementById("chiudiChiedi");
  if (chiudiChiedi) chiudiChiedi.onclick = function () { chiedi.classList.remove("aperto"); };
  chiedi.onclick = function (e) { if (e.target === chiedi) chiedi.classList.remove("aperto"); };
}
segna();

/* ============================================================
   ARMOCROMIA
   I quattro elementi non hanno un colore fisso: se lo prendono dal quadro.
   Si legge la palette vera della tela (ritaglio centrale per non pescare
   pavimento e tavolo, quantizzazione grossolana, i grumi piu' pesanti),
   poi ogni elemento tira verso il colore del quadro piu' vicino al proprio
   archetipo — senza mai perdere il carattere: il fuoco resta caldo, l'acqua
   resta fredda, ma sono il caldo e il freddo DI QUESTO QUADRO.
   Su un quadro spento i quattro si spengono insieme: e' onesto, ed e' bello.
   Nessun dato da preparare: vale per tutti i quadri, sempre.
   ============================================================ */
(function () {

  function aHsl(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2, h = 0, s = 0;
    if (mx !== mn) {
      var d = mx - mn;
      s = l > .5 ? d / (2 - mx - mn) : d / (mx + mn);
      if (mx === r) h = ((g - b) / d + (g < b ? 6 : 0));
      else if (mx === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h *= 60;
    }
    return { h: h, s: s, l: l };
  }
  function daHsl(h, s, l) {
    h = ((h % 360) + 360) % 360 / 360;
    function q(p, q2, t) {
      if (t < 0) t += 1; if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q2 - p) * 6 * t;
      if (t < 1 / 2) return q2;
      if (t < 2 / 3) return p + (q2 - p) * (2 / 3 - t) * 6;
      return p;
    }
    if (!s) { var v = Math.round(l * 255); return "#" + ((1 << 24) + (v << 16) + (v << 8) + v).toString(16).slice(1); }
    var b = l < .5 ? l * (1 + s) : l + s - l * s, a = 2 * l - b;
    var R = Math.round(q(a, b, h + 1 / 3) * 255), G = Math.round(q(a, b, h) * 255), B = Math.round(q(a, b, h - 1 / 3) * 255);
    return "#" + ((1 << 24) + (R << 16) + (G << 8) + B).toString(16).slice(1);
  }
  function delta(a, b) { var d = ((a - b) % 360 + 540) % 360 - 180; return d; }

  /* l'archetipo: dove sta il colore di un elemento quando il quadro non parla.
     h = la direzione, s/l = il carattere (il fuoco brucia, la terra e' opaca,
     l'aria e' chiara e sottile, l'acqua e' fonda). l resta fisso: cosi' il
     testo si legge sempre sul nero, qualunque quadro sia. */
  var ANC = {
    aria:  { h: 205, s: .30, l: .82, drift: 42 },
    fuoco: { h:  20, s: .94, l: .57, drift: 24 },
    terra: { h:  38, s: .44, l: .46, drift: 26 },
    acqua: { h: 192, s: .64, l: .58, drift: 36 }
  };
  var ORDINE = ["fuoco", "acqua", "terra", "aria"];   /* chi ha piu' carattere sceglie prima */

  function leggiPalette(img) {
    var n = 72, cv = document.createElement("canvas");
    cv.width = cv.height = n;
    var g = cv.getContext("2d", { willReadFrequently: true });
    var lw = img.naturalWidth || img.width, lh = img.naturalHeight || img.height;
    if (!lw || !lh) return null;
    var lato = Math.min(lw, lh) * .8;              /* il centro: la' c'e' la tela */
    g.drawImage(img, (lw - lato) / 2, (lh - lato) / 2, lato, lato, 0, 0, n, n);
    var d;
    try { d = g.getImageData(0, 0, n, n).data; } catch (e) { return null; }
    var bin = {}, tot = 0;
    for (var i = 0; i < d.length; i += 4) {
      if (d[i + 3] < 128) continue;
      var r = d[i], v = d[i + 1], b = d[i + 2];
      var k = (r >> 4) * 256 + (v >> 4) * 16 + (b >> 4);
      var o = bin[k] || (bin[k] = { n: 0, r: 0, g: 0, b: 0 });
      o.n++; o.r += r; o.g += v; o.b += b; tot++;
    }
    var out = [];
    for (var k2 in bin) {
      var q = bin[k2], c = aHsl(q.r / q.n, q.g / q.n, q.b / q.n);
      c.w = q.n / tot; c.id = k2; out.push(c);
    }
    out.sort(function (a, b) { return b.w - a.w; });
    return out.slice(0, 18);
  }

  function armonizza(pal) {
    /* quanto e' colorato questo quadro in tutto: decide se la pagina canta
       o resta di cenere. Un quadro grigio non si vede colorato per forza. */
    var croma = 0;
    pal.forEach(function (c) { croma += c.s * c.w; });
    croma = Math.min(1, croma / .3);

    var scelti = {}, presi = {};
    ORDINE.forEach(function (k) {
      var A = ANC[k], best = null, pt = -1;
      pal.forEach(function (c) {
        if (c.l < .07 || c.l > .95 || c.s < .1) return;   /* i grigi non danno direzione */
        var aff = 1 - Math.abs(delta(c.h, A.h)) / 180;
        var p = Math.pow(aff, 2.6) * (.35 + .65 * c.s) * (.3 + .7 * Math.pow(c.w, .3));
        if (presi[c.id]) p *= .3;      /* due elementi non si vestono uguale */
        if (p > pt) { pt = p; best = c; }
      });
      var h = A.h, s = A.s * (.36 + .64 * croma);
      if (best) {
        presi[best.id] = 1;
        h = A.h + Math.max(-A.drift, Math.min(A.drift, delta(best.h, A.h)));
        s = Math.max(.14, Math.min(k === "terra" ? .58 : .96, A.s * (.55 + .7 * best.s)));
      }
      scelti[k] = { h: h, s: s, l: A.l };
    });

    /* fuoco e terra sono vicini di casa: se si toccano non li distingui piu'.
       Si allontanano ciascuno dalla parte del proprio archetipo. */
    var MIN = 20, df = delta(scelti.terra.h, scelti.fuoco.h);
    if (Math.abs(df) < MIN) {
      var manca = (MIN - Math.abs(df)) / 2, verso = df >= 0 ? 1 : -1;
      scelti.terra.h += manca * verso;
      scelti.fuoco.h -= manca * verso;
    }

    /* la quintessenza: fra i colori piu' presenti, il piu' vivo. E' il quadro. */
    var q = null, qp = -1;
    pal.slice(0, 9).forEach(function (c) {
      var p = c.s * (.35 + .65 * Math.pow(c.w, .3));
      if (p > qp) { qp = p; q = c; }
    });
    var quinta = q && q.s > .12
      ? daHsl(q.h, Math.min(.74, Math.max(.32, q.s * .95)), Math.min(.68, Math.max(.56, q.l)))
      : "#cfc6b2";

    var st = document.documentElement.style;
    Object.keys(scelti).forEach(function (k) {
      var c = scelti[k], hex = daHsl(c.h, c.s, c.l);
      st.setProperty("--" + k, hex);
      ELEMENTI.forEach(function (E) { if (E.k === k) E.col = hex; });
    });
    st.setProperty("--quinta", quinta);
    if (window.dipingiSigilli) dipingiSigilli();
    if (window.segna) segna();
  }

  /* si puo' richiamare quando l'opera cambia (in negozio la sceglie il tema) */
  window.armocromia = function (src) {
    var im = new Image();
    im.crossOrigin = "anonymous";
    im.onload = function () { var pal = leggiPalette(im); if (pal && pal.length) armonizza(pal); };
    im.onerror = function () { /* niente palette: restano i colori d'archetipo */ };
    im.src = src || document.querySelector("#tela img").getAttribute("src");
  };
  window.armocromia();

})();

/* ============================================================
   IL CAOS: quattro campi procedurali, uno per elemento.
   La densita' di ogni campo e' proporzionale a quanti contenuti
   ha quell'elemento — un quadro senza video ha l'acqua secca,
   e lo si vede prima di leggere qualsiasi numero.
   ============================================================ */
(function () {
  var c = document.getElementById("fondo"), x = c.getContext("2d"), w, h, dpr;
  function dim() {
    dpr = Math.min(devicePixelRatio || 1, 2);
    w = c.width = innerWidth * dpr; h = c.height = innerHeight * dpr;
    c.style.width = innerWidth + "px"; c.style.height = innerHeight + "px";
  }
  dim(); addEventListener("resize", dim);

  var P = [];
  function nasci(E) {
    var p = { e: E.k, E: E };
    if (E.k === "aria")  { p.x = Math.random(); p.y = .5 + Math.random() * .55; p.r = Math.random() * 1.1 + .3;
                           p.v = Math.random() * .0011 + .0004; p.f = Math.random() * 6.28; p.o = Math.random() * .34 + .06; }
    if (E.k === "fuoco") { p.x = .72 + Math.random() * .32; p.y = .55 + Math.random() * .55; p.r = Math.random() * 1.4 + .35;
                           p.v = Math.random() * .0034 + .0016; p.f = Math.random() * 6.28; p.o = Math.random() * .3 + .07; }
    if (E.k === "acqua") { p.x = -.05 + Math.random() * .36; p.y = Math.random(); p.r = Math.random() * 1.3 + .35;
                           p.v = Math.random() * .0013 + .0005; p.f = Math.random() * 6.28; p.o = Math.random() * .34 + .08; }
    if (E.k === "terra") { p.x = Math.random(); p.y = -.05 + Math.random() * .55; p.r = Math.random() * 1.5 + .5;
                           p.v = Math.random() * .0009 + .0003; p.f = 0; p.o = Math.random() * .3 + .08; }
    return p;
  }
  ELEMENTI.forEach(function (E) {
    /* niente contenuti = campo quasi spento, non vuoto: resta un'eco */
    var q = E.n ? 20 + E.n * 21 : 5;
    for (var i = 0; i < q; i++) P.push(nasci(E));
  });

  var t = 0;
  (function giro() {
    t += .012;
    /* niente cancellazione netta: una velatura, cosi' ogni particella lascia
       la sua scia e il fondo diventa un disegno che si rifa' da solo */
    x.globalCompositeOperation = "source-over";
    x.fillStyle = "rgba(7,7,10,.13)"; x.fillRect(0, 0, w, h);
    x.globalCompositeOperation = "lighter";
    for (var i = 0; i < P.length; i++) {
      var p = P[i];
      if (p.e === "aria") {                       /* sale e deriva, sinuosa */
        p.y -= p.v; p.x += Math.sin(t + p.f) * .0006;
        if (p.y < -.03) { p.y = 1.03; p.x = Math.random(); }
      } else if (p.e === "fuoco") {               /* scintille che salgono guizzando */
        p.y -= p.v; p.x += Math.sin(t * 2.4 + p.f) * .0013;
        if (p.y < .1) { p.y = .58 + Math.random() * .55; p.x = .72 + Math.random() * .32; }
      } else if (p.e === "acqua") {               /* scorre e ondeggia */
        p.x += p.v * .7; p.y += Math.sin(t * 1.1 + p.f) * .0009;
        if (p.x > .38) { p.x = -.05; p.y = Math.random(); }
      } else {                                    /* terra: cade e si deposita */
        p.y += p.v;
        if (p.y > 1.03) { p.y = -.03; p.x = Math.random(); }
      }
      var op = p.o;
      if (p.e === "terra") op = p.o * 1.5 * Math.min(1, p.y * 1.4);
      if (p.e === "fuoco") op = p.o * (1 - Math.max(0, (.66 - p.y) * 1.3));
      x.globalAlpha = Math.max(0, op);
      x.fillStyle = x.strokeStyle = p.E.col;
      var X = p.x * w, Y = p.y * h, R = p.r * dpr;
      if (p.e === "aria") {                 /* filamenti: un respiro che si vede */
        x.globalAlpha *= 1.15; x.lineWidth = R * .45; x.beginPath();
        x.moveTo(X, Y);
        x.quadraticCurveTo(X + Math.sin(t + p.f) * R * 9, Y + R * 6,
                           X + Math.sin(t * .7 + p.f) * R * 4, Y + R * 13);
        x.stroke();
      } else if (p.e === "acqua") {          /* creste d'onda lunghe */
        x.globalAlpha *= .42; x.lineWidth = R * .5; x.beginPath();
        x.arc(X, Y, R * 13, .72, 1.86); x.stroke();
      } else if (p.e === "terra") {          /* grani squadrati che si posano */
        x.fillRect(X, Y, R * 1.9, R * 1.9);
      } else {                               /* braci, con l'alone */
        x.beginPath(); x.arc(X, Y, R, 0, 6.284); x.fill();
        x.globalAlpha *= .085; x.beginPath(); x.arc(X, Y, R * 4, 0, 6.284); x.fill();
      }
    }
    x.globalAlpha = 1; x.globalCompositeOperation = "source-over";
    requestAnimationFrame(giro);
  })();
})();
